class GlobalErrorMessages {
    static SERVER_COMMUNICATION_FAILURE = `Connection to server lost. Please check your internet connection.`;
    static SOMETHING_WENT_WRONG = `Unknown error`;
}

export default GlobalErrorMessages;
